import React from 'react';

export const MyProfileLoadingCard = () => {
    return (
        <div className="card card__no-border">
            <div className="card-body py-4 d-flex align-items-center gap-2 text-primary fw-semibold">
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                Cargando información de perfil...
            </div>
        </div>
    );
};
